import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AfterViewInit } from '@angular/core';
import { NavbarService } from '../navbar/navbar.service';

declare var UserInterface: any;
declare var HWV_CSR: any;
declare var unload: any;
declare var killPreviousViewer: any;
declare var loadtwoViews: any;
declare var JsonViewerDataMrc: any;
declare var twoViewFunction: any;
declare var superimposeFunction: any;
declare var destroyHWVViewer: any;

@Component({
  // moduleId: module.id,
  selector: 'superimpose',
  templateUrl: 'superimpose.component.html',
  styleUrls: ['superimpose.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class SuperimposeComponent implements OnInit, AfterViewInit {

  hwv: any;
  userInterface: any;
  twoViewFunction: any;
  superimposeFunction: any;
  _service: any;
  hwfurl: string;
  private file: string;
  isvalid: boolean = true;
  tenantid: string = '';

  constructor(private service: SharedService,
    private router: Router,
    private route: ActivatedRoute,
    public navService: NavbarService) {
    this._service = service;
  }

  ngOnInit() {
    this.navService.hide();
    console.log('In Viewer Component. URL:', this.router.url);

    this.tenantid = localStorage.getItem('mr_tenantid');
  }

  ngAfterViewInit() {
    console.log('In ngAfterViewInit Component');

    this.hwfurl = this._service.getData();
    this.loadSuperimposeViews(this.hwfurl);
  }

  ngOnDestroy() {
    new destroyHWVViewer();
  }

  loadSuperimposeViews(hwfURLString: string) {

    this.hwv = new HWV_CSR('theCanvas');
    this.superimposeFunction = new superimposeFunction(this.hwv, hwfURLString);
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/superimpose/superimpose.component.ts